import Rates from './helpers/rates.js';
import Calculations from './helpers/calculations.js';
import { infoBlock } from '../core/info-block.js';

(() => {
	class Calculator {
		/**
		 * Init the class
		 *
		 */
		constructor() {
			const calculate = document.getElementById(
					'calculate-affordability'
				),
				self = this;

			this.addApplicantBtn = document.getElementById('add-applicant');
			this.addHouseholdBtn = document.getElementById('add-household');
			this.propertyValue = document.getElementById('property-value');
			this.mortType = document.getElementById('repayment-type');
			this.prodType = document.getElementById('product-length');
			this.mortTerm = document.getElementById('mortgage-term-years');
			this.accordionTitles = document.querySelectorAll(
				'.form-accordion-title'
			);
			this.stepBtns = document.querySelectorAll('.btn-step');
			this.householdSection =
				document.getElementById('household-section');
			this.applicantSection =
				document.getElementById('applicant-section');
			this.output = document.getElementById('output-box');
			this.amtBorrow = document.getElementById('mortgage-required');
			this.amtCapRepay = document.getElementById(
				'capital-repayment-amount'
			);
			this.interestOnlyAmt = document.getElementById(
				'interest-only-amount'
			);
			this.stressRate = parseFloat(
				document.getElementById('affordability-calculator').dataset
					.stressRate
			);
			this.calculations = new Calculations();
			this.rates = new Rates();

			this.addApplicantBtn.addEventListener(
				'click',
				this.addApplicant.bind(this)
			);
			this.addHouseholdBtn.addEventListener(
				'click',
				this.addHousehold.bind(this)
			);
			calculate.addEventListener('click', this.doCalculations.bind(this));

			// Select changes
			this.mortType.addEventListener(
				'change',
				this.checkType.bind(this, 'repayment-type-value')
			);
			this.prodType.addEventListener(
				'change',
				this.checkProdType.bind(this)
			);

			// Input change
			this.amtBorrow.addEventListener(
				'change',
				this.updateInterestOnlyAmt.bind(this)
			);
			this.amtCapRepay.addEventListener(
				'change',
				this.updateInterestOnlyAmt.bind(this)
			);

			// Remove applicant
			document.addEventListener('click', function (e) { // eslint-disable-line
				if (
					e.target &&
					e.target.classList.contains('remove-applicant')
				) {
					e.preventDefault();
					const removeElement =
							e.target.parentNode.getAttribute('id'),
						currentCount = self.applicantSection.dataset.count;

					document.getElementById(removeElement).remove();

					//Update count
					self.applicantSection.dataset.count =
						document.querySelectorAll('.applicant-fields').length;

					//Check if add button needs to be added back
					if (currentCount <= 4) {
						self.addApplicantBtn.classList.remove('hide');
					} else {
						self.addApplicantBtn.classList.add('hide');
					}
				}

				if (
					e.target &&
					e.target.classList.contains('remove-household')
				) {
					e.preventDefault();
					const removeElement =
							e.target.parentNode.getAttribute('id'),
						currentCount = self.householdSection.dataset.count;

					document.getElementById(removeElement).remove();

					//Update count
					self.householdSection.dataset.count =
						document.querySelectorAll('.household-fields').length;

					//Check if add button needs to be added back
					if (currentCount <= 4) {
						self.addHouseholdBtn.classList.remove('hide');
					} else {
						self.addHouseholdBtn.classList.add('hide');
					}
				}
			});

			// Toggle accordions
			this.accordionTitles.forEach((title) => {
				title.addEventListener('click', function () {
					const activeClass = 'accordion-section__open';
					const parent = title.closest('.accordion-section');
					const isOpen = parent.classList.contains(activeClass);
					if (!isOpen) {
						parent.classList.add(activeClass);
					} else {
						parent.classList.remove(activeClass);
					}
				});
			});

			// Move to next accordion step
			this.stepBtns.forEach((btn) => {
				btn.addEventListener('click', function (e) {
					e.preventDefault();
					const id = this.getAttribute('data-step');
					const sibling = document.getElementById(id);

					sibling.classList.add('accordion-section__open');
				});
			});
		}

		checkType(selector) {
			const mortType = this.mortType.value,
				repaymentType = document.querySelectorAll('.' + selector);

			repaymentType.forEach((field) => {
				if (field.dataset.selectValue === mortType) {
					field.classList.remove('form-element-hidden');
				} else {
					field.classList.add('form-element-hidden');
				}
			});
		}

		checkProdType() {
			const prodType = this.prodType.value,
				interestRate = document.getElementById('product-interest-rate');
			if (prodType === 'fixed' || prodType === 'lifetime') {
				interestRate.classList.remove('form-element-hidden');
			} else {
				interestRate.classList.add('form-element-hidden');
			}
		}

		updateInterestOnlyAmt() {
			const amtBorrow = parseInt(this.amtBorrow.value, 10);
			let interestAmt = amtBorrow;
			if (this.amtCapRepay.value) {
				const amtCapRepay = parseInt(this.amtCapRepay.value, 10);
				interestAmt = amtBorrow - amtCapRepay;
			}
			this.interestOnlyAmt.value = interestAmt;
		}

		addApplicant(e) {
			e.preventDefault();
			const applicantFields = document
				.getElementById('applicant-1')
				.cloneNode(true);
			let applicantNumber =
				document.getElementById('applicant-section').dataset.count;

			//Update count
			applicantNumber++;
			this.applicantSection.dataset.count = applicantNumber;

			// Clone fields
			const currentCount = this.applicantSection.dataset.count,
				fields = applicantFields.querySelectorAll('input');

			applicantFields.dataset.applicant = currentCount;
			applicantFields.setAttribute('id', 'applicant-' + currentCount);

			fields.forEach((field) => {
				const name = field.dataset.name + '-' + currentCount;
				field.setAttribute('name', name);
			});

			if (currentCount >= 4) {
				this.addApplicantBtn.classList.add('hide');
			} else {
				this.addApplicantBtn.classList.remove('hide');
			}

			if (currentCount < 5) {
				applicantFields.innerHTML +=
					'<button class="remove-applicant btn btn-danger">Remove applicant</button>';
				this.applicantSection.appendChild(applicantFields);
			}
		}

		addHousehold(e) {
			e.preventDefault();

			const householdFields = document
				.getElementById('household-1')
				.cloneNode(true);
			let householdNumber =
				document.getElementById('household-section').dataset.count;

			//Update count
			householdNumber++;
			this.householdSection.dataset.count = householdNumber;

			// Clone fields
			const currentCount = this.householdSection.dataset.count,
				fields = householdFields.querySelectorAll('input');

			householdFields.dataset.household = currentCount;
			householdFields.setAttribute('id', 'household-' + currentCount);

			fields.forEach((field) => {
				const name = field.dataset.name + '-' + currentCount;
				field.setAttribute('name', name);
			});

			if (currentCount >= 4) {
				this.addHouseholdBtn.classList.add('hide');
			} else {
				this.addHouseholdBtn.classList.remove('hide');
			}

			if (currentCount < 5) {
				householdFields.innerHTML +=
					'<button class="remove-household btn btn-danger ">Remove household</button>';
				this.householdSection.appendChild(householdFields);
			}
		}

		doCalculations(e) {
			e.preventDefault();
			const self = this;

			// Variables
			const amtIntRepay = 0;
			let stressedIntRate,
				amtCapRepayMonthly = 0,
				amtIntRepayAmount = 0,
				repAmount = 0,
				expenditureByRegions = 0,
				totalExpenses = 0,
				netMonthlyIncome = 0,
				maximumLoan = 0,
				netFreePay = 0,
				monthlyIncomeTolerance = 0,
				decision,
				decisionText;

			const amtBorrow = parseInt(
					document.getElementById('mortgage-required').value
				),
				propertyValue = parseInt(
					document.getElementById('property-value').value
				),
				mortTerm =
					parseInt(
						document.getElementById('mortgage-term-years').value
					) * 12,
				mortType = document.getElementById('repayment-type').value,
				prodType = document.getElementById('product-length').value,
				intRate = parseFloat( // eslint-disable-line
					document.getElementById('interest-rate').value
				),
				amtCapRepay = parseInt( // eslint-disable-line
					document.getElementById('capital-repayment-amount').value
				),
				debtConsolidation =
					document.getElementById('debt-consolidation').value,
				creditRepaymentHistory = document.getElementById(
					'credit-repayment-history'.value
				);

			const applicantSections = // eslint-disable-line
				document.querySelectorAll('.applicant-fields');
			const householdSections = // eslint-disable-line
				document.querySelectorAll('.household-fields');

			// Loan to value
			let ltv = self.calculations.calculateLtv(amtBorrow, propertyValue), // eslint-disable-line
				ltvPcent = (ltv * 100).toFixed(3), // eslint-disable-line
				incomeMultiplier = 4.49; // Updated 18 Nov 2021 as per Ismail - no longer limit the 4.49 LTI to customers below 80% LTV, it is now available as standard to all.

			if (debtConsolidation === 'yes') {
				incomeMultiplier = 4;
			}

			if (creditRepaymentHistory === 'no') {
				incomeMultiplier = 4;
			}

			if (this.checkFirstFields()) {
				return false;
			}

			// [CALC the Stressed Interest Rate - depend upon prodType]
			switch (prodType) {
				case 'other':
					stressedIntRate = this.stressRate;
					break;
				case 'selfbuild':
					stressedIntRate = this.stressRate;
					break;
				case 'fixed':
					stressedIntRate = intRate;
					break;
				case 'lifetime':
					stressedIntRate = parseFloat(intRate + 3.0).toFixed(2);
					break;
			}

			// [CALC Monthly Mortgage RePayment]
			// Capital repayment OR Interest only OR Part Capital & Part Interest
			switch (mortType) {
				case 'capital':
					repAmount = self.calculations.calcRepaymentsCapital(
						amtBorrow,
						stressedIntRate / 1200,
						mortTerm
					);
					break;
				case 'interest':
					repAmount = self.calculations.calcRepaymentsInterest(
						amtBorrow,
						stressedIntRate / 1200
					);
					break;
				case 'partnpart':
					amtCapRepayMonthly =
						self.calculations.calcRepaymentsCapital(
							amtCapRepay,
							stressedIntRate / 1200,
							mortTerm
						);
					amtIntRepayAmount =
						self.calculations.calcRepaymentsInterest(
							amtIntRepay,
							stressedIntRate / 1200
						);
					repAmount = parseInt(
						amtCapRepayMonthly + amtIntRepayAmount
					);
					break;
			}

			// [CALC Expenditure by Region]
			householdSections.forEach((householdSection) => {
				const resRegion =
						householdSection.querySelector(
							'#property-region'
						).value,
					resHouseOcc = householdSection.querySelector(
						'#household-occupancy-composition'
					).value,
					resCTaxRed = householdSection.querySelector(
						'#res-council-tax-reduction'
					).value;

				// Get Household Occ Weighting
				const houseOccWeight =
					self.rates.get_household_occ_weight(resHouseOcc);
				// Calc Region Expense
				const expenseRegion =
					self.rates.get_region_expenditure(resRegion);
				// Calc Region CTax expence
				const expenseCTax = self.rates.get_region_counciltax(resRegion);

				let expenditureByRegion = 0;

				// Work out Total Exp per region factoring in any CTax reduction
				if (resCTaxRed === 'yes') {
					// Reduced council tax - only factor in 75% of charge
					expenditureByRegion = (
						expenseRegion * houseOccWeight +
						expenseCTax * 0.75
					).toFixed(2);
				} else {
					// Std council tax - full 100% charge
					expenditureByRegion = (
						expenseRegion * houseOccWeight +
						expenseCTax * 1
					).toFixed(2);
				}

				expenditureByRegions += parseFloat(expenditureByRegion);
			});

			// [CALC Total Gross Income & Net Income after Tax]
			const applicants = [];

			applicantSections.forEach((applicantSection) => {
				const individualGrossIncome = self.calculations.calculateTotal(
					applicantSection.querySelector('.applicant-income')
				);
				const applicantExpenses = parseFloat(
					self.calculations.calculateTotal(
						applicantSection.querySelector(
							'.applicant-expenditure'
						),
						['loans', 'other-mortgages', 'overdraft']
					) * 12
				);

				netMonthlyIncome += parseFloat(
					self.rates.calc_monthly_net_income(individualGrossIncome)
				);

				totalExpenses += parseFloat(
					self.calculations.calculateTotal(
						applicantSection.querySelector('.applicant-expenditure')
					)
				);

				const applicantValue =
					individualGrossIncome - applicantExpenses;
				applicants.push(applicantValue);
			});

			const sortedApplicants = applicants.sort(function (a, b) {
				return b - a;
			});
			sortedApplicants.forEach((applicant, i) => {
				if (i < 2) {
					maximumLoan +=
						parseFloat(applicant) * parseFloat(incomeMultiplier);
				} else {
					maximumLoan += parseFloat(applicant);
				}
			});

			maximumLoan = maximumLoan.toFixed(2);

			netFreePay = (
				parseFloat(netMonthlyIncome) -
				(parseFloat(expenditureByRegions) +
					parseFloat(totalExpenses) +
					parseFloat(repAmount))
			).toFixed(0);

			monthlyIncomeTolerance = parseFloat(
				parseFloat(netMonthlyIncome) * 0.05
			).toFixed(0);

			//Work out output message
			this.output.innerHTML = '';

			const netFreePayPcent = (
				(netFreePay / parseFloat(netMonthlyIncome)) *
				100
			).toFixed(2);

			if (ltvPcent > 95.0) {
				this.output.classList.add('alert-danger');
				decision = '<h4>FAIL</h4>';
				decisionText =
					'Based on the information input and modelled data, the application fails our affordability criteria as the LTV exceeds 95% limit. ';
			} else if (
				maximumLoan >= amtBorrow &&
				parseInt(netFreePay) >= parseInt(monthlyIncomeTolerance)
			) {
				this.output.classList.add('alert-success');
				decision = '<h4>PASS</h4>';
				decisionText =
					'Based on the information input and modelled data, the application meets our affordability criteria.<br><br> ';
				decisionText +=
					'Please contact us if you have any additional material information you would like to bring to our attention ';
				decisionText +=
					"or if your client's expenditure is unlikely to correspond with modelled data.";
				decisionText +=
					'<br><br><strong>The affordability system is for information purposes only. The Society decides at its absolute discretion whether to lend and the terms on which it is prepared to lend.</strong> ';
			} else {
				this.output.classList.add('alert-danger');
				decision = '<h4>FAIL</h4>';
				decisionText =
					'Based on the information input and modelled data, the application fails our affordability criteria. ';
				decisionText +=
					'Please contact us to discuss this if you have any additional material information you would like to bring to our attention ';
				decisionText +=
					"or if your client's expenditure is unlikely to correspond with modelled data.";
			}

			this.output.innerHTML += decision + decisionText;
			// this.output.innerHTML += `<br><p>LTV: ${ltvPcent}%</p>`;
			// this.output.innerHTML += `<p>LTI Multiple: ${incomeMultiplier}</p>`;
			// this.output.innerHTML += `<p>Stressed interest rate: ${stressedIntRate}%</p>`;
			// this.output.innerHTML += `<br>`;
			// this.output.innerHTML += `<div class="form-group"><label class="form-label">Maximum Loan:</label><div class="form-input-container"><div class="input-group"><span class="input-group-addon">£</span>`;
			// this.output.innerHTML += `<input value="${maximumLoan}" type="number" class="form-control">`;
			// this.output.innerHTML += `</div><p class="help-block"><small>based on income multiples</small></p></div></div>`;

			this.output.innerHTML += `<div class="form-group ">`;
			this.output.innerHTML += `<label class="form-label">Maximum Loan:</label>`;
			this.output.innerHTML += `<div class="form-input-container "><div class="input-group"><span class="input-group-addon">£</span><input value="${maximumLoan}" type="number" class="form-control" readonly><div class="info-block">
                            <img loading="lazy" width="18" height="18" src="/wp-content/themes/hinckley-and-rugby/resources/images/svg/info.svg">
                            <div class="info-block__message">
                                <div class="info-block__message--container">
                                    <div class="info-block__message--title">Maximum Loan</div>
                                    <div class="info-block__message--content"><p>Please note this is purely based on income and does not take into account ONS figures.</p></div>
                                </div>
                            </div>
                        </div></div>`;
			this.output.innerHTML += `</div><p class="help-block"><small>hint: whole numbers &amp; no commas</small></p></div></div>`;

			this.output.innerHTML += `<div class="form-group ">`;
			this.output.innerHTML += `<label class="form-label">Net free pay %</label>`;
			this.output.innerHTML += `<div class="form-input-container "><div class="input-group"><input value="${netFreePayPcent}" type="number" class="form-control" readonly><span class="input-group-addon">%</span><div class="info-block">
                            <img loading="lazy" width="18" height="18" src="/wp-content/themes/hinckley-and-rugby/resources/images/svg/info.svg">
                            <div class="info-block__message">
                                <div class="info-block__message--container">
                                    <div class="info-block__message--title">Net free pay %</div>
                                    <div class="info-block__message--content"><p>Please note the Net free pay % would need to be at least 5% for us to consider lending.</p></div>
                                </div>
                            </div>
                        </div></div>`;
			this.output.innerHTML += `</div><p class="help-block"><small>hint: whole numbers &amp; no commas</small></p></div></div>`;

			infoBlock();
		}

		checkFirstFields() {
			// Check fields
			this.output.classList.remove('alert-success');
			this.output.classList.remove('alert-danger');
			const errors = this.calculations.validateFields([
				this.amtBorrow,
				this.propertyValue,
				this.mortTerm,
			]);
			if (errors) {
				this.output.classList.add('alert-danger');
				this.output.innerHTML = 'Please check for errors';
				document
					.getElementById('step-1')
					.classList.add('accordion-section__open');
				return true;
			}
		}
	}

	new Calculator();
})();
